<div
  *transloco="let t; read: 'widgets.analytic-item-selector'"
  class="xi-modal__container widget-analytic-item__container"
  [ngClass]="{ '__increase-size': isSectionSelectorAvailable }"
>
  <h2 class="xi-modal__title">{{ t('analytic-item') }}</h2>

  <div class="xi-modal__content widget-analytic-item__content">
    <div class="filter-header">{{ t('header') }}</div>

    @if (isLoading) {
      <div class="xi-loader-container__center">
        <xi-animation
          [width]="300"
          [height]="300"
          [loop]="true"
          animation="cx_loader"
        ></xi-animation>
      </div>
    }
    @if (!isLoading) {
      <div class="widget-analytic-item__selectors">
        <app-analytic-item-selector
          #analyticItemSelector
          [widget]="widget"
          [report]="report"
          [widgetDataSource]="widgetDataSource"
          [analyticItemTypes]="analyticItemTypes"
          (analyticItemChange)="onAnalyticItemChange($event)"
          (subtypesChange)="onSubtypesChange($event)"
        >
        </app-analytic-item-selector>
        @if (isSectionSelectorAvailable) {
          <app-section-selector
            [sectionMetadata]="sectionMetadata"
            [value]="widget.payload.selectedSection"
            (sectionSelect)="onSectionSelected($event)"
          ></app-section-selector>
        }
      </div>
    }
  </div>

  <div class="xi-modal__actions widget-analytic-item__actions">
    <xi-default-button [text]="t('cancel')" fill="text" (onClick)="cancel()"></xi-default-button>

    <xi-default-button
      [text]="t('save')"
      [disabled]="!isValid"
      [tooltipDisplayOnDisabled]="true"
      [tooltip]="saveButtonTooltip"
      (onClick)="save()"
    ></xi-default-button>
  </div>
</div>
